import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
} from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { takeUntil } from 'rxjs/operators';
import { getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';

@Component({
  selector: 'app-certificat-search',
  templateUrl: './certificat-search.component.html',
  styleUrls: ['./certificat-search.component.scss']
})
export class CertificatSearchComponent implements OnInit, OnDestroy {
  @Input() isFermier;
  @Output() searchResult = new EventEmitter();
  certificatSearchForm;
  destroy$: Subject<boolean> = new Subject<boolean>();
  currentRoute;
  exploatatieName;
  exploatatieCode;
  isOnHolding = false;

  constructor(
    private store: Store<ApplicationState>
  ) { }

  ngOnInit(): void {
    this.store.pipe(select(getSelectedHolding))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        if (response) {
          this.exploatatieName = response.name;
          this.exploatatieCode = response.code;
        }
      });

    this.store.pipe(select(getCurrentRoute))
    .pipe(takeUntil(this.destroy$))
    .subscribe((response: string) => {
      this.currentRoute = response;
    });

    this.isOnHolding = this.currentRoute.includes('/dashboard/solicitari-certificate-zootehnice') ? false : true;

    this.certificatSearchForm = new UntypedFormGroup({
      company_name: new UntypedFormControl(this.isOnHolding ? this.exploatatieName : null),
      company_code: new UntypedFormControl(this.isOnHolding ? this.exploatatieCode : null),
      status_doc: new UntypedFormControl(null)
    });

    if (this.isOnHolding) {
      this.certificatSearchForm.controls.company_name.disable();
      this.certificatSearchForm.controls.company_code.disable();
    }
  }

  onSubmitted() {
    this.searchResult.emit(this.certificatSearchForm.value);
  }

  resetSearch() {
    this.certificatSearchForm.reset();
    this.onSubmitted();
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

}
